import React, { Component } from "react";
import { CardElement, injectStripe } from "react-stripe-elements";
import { Button } from "reactstrap";
class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ""
    };
    this.submit = this.submit.bind(this);
  }

  async submit(ev) {
    let res = await this.props.stripe.createToken();
    let { error, token } = res;
    if (error) {
      this.setState({
        error
      });
    } else {
      this.props.submitToken(token.id);
    }
  }

  render() {
    return (
      <div className="checkout">
        <CardElement />
        {this.state.error}
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => this.props.toggleModal("paymentModal")}
          >
            取消
          </Button>
          <Button color="primary" type="button" onClick={this.submit} disabled={this.props.disabled}>
            確認付款
          </Button>
        </div>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);
